import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Venue from "./pages/Venue";
import Highlights from "./pages/Highlights";
import Contact from "./pages/Contact";
import Update from "./pages/Update";
import Post from "./pages/Post";
import Videos from "./pages/Videos";
import Modal from "react-modal"; // or your preferred modal solution
import { IoClose } from "react-icons/io5"; // for the close icon
import "./App.css";

// Make sure to bind modal to your appElement
Modal.setAppElement('#root');

const App = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if the popup was previously closed in this session
    const sessionClosed = sessionStorage.getItem('popupClosed');
    
    // Only show if not previously closed in this session
    if (!sessionClosed) {
      setShowPopup(true);
    }
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    // Mark as closed in sessionStorage so it doesn't show again until browser is closed
    sessionStorage.setItem('popupClosed', 'true');
  };

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/stalldetails" element={<Update />} />
        <Route path="/posts" element={<Post />} />
        <Route path="/venue" element={<Venue />} />
        <Route path="/highlights" element={<Highlights />} />
        <Route path="/videos" element={<Videos />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />

      {/* Popup Modal */}
      <Modal
        isOpen={showPopup}
        onRequestClose={closePopup}
        contentLabel="Welcome Popup"
        className="popup-modal"
        overlayClassName="popup-overlay"
      >
        <button onClick={closePopup} className="close-popup">
          <IoClose size={24} />
        </button>
        <img 
          src="/imagesebf/poster.jpg" 
          alt="Special Offer" 
          className="popup-image"
        />
      </Modal>
    </Router>
  );
};

export default App;